import {
  useDomEvent as useDomEventBase,
  usePointerDomEvent as usePointerDomEventBase,
  useWindowDomEvent as useWindowDomEventBase,
} from '@repo/hooks-use-dom-event'

export const useDomEvent = useDomEventBase
export const usePointerDomEvent = usePointerDomEventBase
export const useWindowDomEvent = useWindowDomEventBase
